import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetTagsQueryResponse, GetTagsQueryParams } from "../types/GetTags";

export const getTagsQueryKey = (params?: GetTagsQueryParams) =>     [{url:`/api/ms-content-infoportal-backend/v1/tags`},...(params ? [params] : [])] as const;
      export function getTagsQueryOptions <TData = GetTagsQueryResponse, TError = unknown>(params?: GetTagsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getTagsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/ms-content-infoportal-backend/v1/tags`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/ms-content-infoportal-backend/v1/tags
 */

export function useGetTags <TData = GetTagsQueryResponse, TError = unknown>(params?: GetTagsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTagsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getTagsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
